<template>
  <div class="consumption-create-container">
    <h2>添加消费记录</h2>
    <el-card shadow="hover">
      <el-form
        :model="consumptionForm"
        :rules="rules"
        ref="consumptionFormRef"
        label-position="top"
        label-width="120px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="用户ID" prop="user_id">
              <el-input v-model="consumptionForm.user_id" placeholder="请输入用户ID" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="消费单号" prop="consumption_no">
              <el-input v-model="consumptionForm.consumption_no" placeholder="请输入消费单号" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="消费类型" prop="type">
              <el-select v-model="consumptionForm.type" placeholder="请选择消费类型">
                <el-option label="房间消费" value="room" />
                <el-option label="餐饮消费" value="food" />
                <el-option label="娱乐消费" value="entertainment" />
                <el-option label="其他消费" value="other" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="status">
              <el-radio-group v-model="consumptionForm.status">
                <el-radio label="completed">已完成</el-radio>
                <el-radio label="pending">未完成</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="消费时间" prop="consumption_time">
              <el-date-picker
                v-model="consumptionForm.consumption_time"
                type="datetime"
                placeholder="选择日期时间"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="总金额" prop="total_amount">
              <el-input v-model="consumptionForm.total_amount" type="number" placeholder="请输入总金额" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="描述" prop="description">
              <el-input v-model="consumptionForm.description" type="textarea" placeholder="请输入消费描述" rows="4" />
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <h3>消费项目</h3>
            <el-table :data="consumptionItems" style="width: 100%" border>
              <el-table-column prop="name" label="项目名称" />
              <el-table-column prop="quantity" label="数量" />
              <el-table-column prop="unit_price" label="单价" />
              <el-table-column prop="total_price" label="总价" />
              <el-table-column label="操作" width="100">
                <template #default="scope">
                  <el-button type="danger" size="small" @click="handleRemoveItem(scope.$index)">
                    <el-icon><delete /></el-icon> 删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            
            <el-button type="success" @click="handleAddItem" style="margin-top: 10px;">
              <el-icon><plus /></el-icon> 添加消费项目
            </el-button>
          </el-col>
        </el-row>
        
        <div class="form-actions">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" @click="handleSubmit">提交</el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { Plus, Delete } from '@element-plus/icons-vue';
import request from '../../api/axios';

export default {
  name: 'ConsumptionCreate',
  components: {
    Plus,
    Delete
  },
  setup() {
    const router = useRouter();
    const consumptionFormRef = ref(null);
    
    const consumptionForm = ref({
      user_id: '',
      consumption_no: '',
      type: 'room',
      status: 'completed',
      consumption_time: new Date(),
      total_amount: 0,
      description: ''
    });
    
    const consumptionItems = ref([
      {
        name: '',
        quantity: 1,
        unit_price: 0,
        total_price: 0
      }
    ]);
    
    const rules = {
      user_id: [
        { required: true, message: '请输入用户ID', trigger: 'blur' },
        { type: 'number', message: '用户ID必须是数字', trigger: 'blur' }
      ],
      consumption_no: [
        { required: true, message: '请输入消费单号', trigger: 'blur' }
      ],
      type: [
        { required: true, message: '请选择消费类型', trigger: 'change' }
      ],
      status: [
        { required: true, message: '请选择状态', trigger: 'change' }
      ],
      consumption_time: [
        { required: true, message: '请选择消费时间', trigger: 'change' }
      ],
      total_amount: [
        { required: true, message: '请输入总金额', trigger: 'blur' },
        { type: 'number', min: 0, message: '总金额必须大于等于0', trigger: 'blur' }
      ]
    };
    
    // 添加消费项目
    const handleAddItem = () => {
      consumptionItems.value.push({
        name: '',
        quantity: 1,
        unit_price: 0,
        total_price: 0
      });
    };
    
    // 删除消费项目
    const handleRemoveItem = (index) => {
      if (consumptionItems.value.length > 1) {
        consumptionItems.value.splice(index, 1);
        updateTotalAmount();
      } else {
        ElMessage.warning('至少需要一个消费项目');
      }
    };
    
    // 更新总金额
    const updateTotalAmount = () => {
      let total = 0;
      consumptionItems.value.forEach(item => {
        item.total_price = item.quantity * item.unit_price;
        total += item.total_price;
      });
      consumptionForm.value.total_amount = total;
    };
    
    // 监听消费项目变化，自动更新总金额
    const watchConsumptionItems = () => {
      consumptionItems.value.forEach(item => {
        item.quantity = Number(item.quantity) || 0;
        item.unit_price = Number(item.unit_price) || 0;
      });
      updateTotalAmount();
    };
    
    // 提交表单
    const handleSubmit = async () => {
      if (!consumptionFormRef.value) return;
      
      // 更新总金额
      watchConsumptionItems();
      
      await consumptionFormRef.value.validate(async (valid) => {
        if (valid) {
          try {
            await request({
              url: '/manage/consumptions',
              method: 'post',
              data: {
                ...consumptionForm.value,
                items: consumptionItems.value
              }
            });
            ElMessage.success('消费记录创建成功');
            router.push('/consumptions/list');
          } catch (error) {
            ElMessage.error('消费记录创建失败');
            console.error(error);
          }
        } else {
          return false;
        }
      });
    };
    
    // 取消操作
    const handleCancel = () => {
      router.push('/consumptions/list');
    };
    
    return {
      consumptionForm,
      consumptionFormRef,
      consumptionItems,
      rules,
      handleAddItem,
      handleRemoveItem,
      handleSubmit,
      handleCancel
    };
  }
};
</script>

<style scoped>
.consumption-create-container {
  padding: 20px;
}

.consumption-create-container h2 {
  margin-bottom: 20px;
  color: #333;
}

.consumption-create-container h3 {
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}

.form-actions .el-button {
  margin-left: 10px;
}
</style>